<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <div class="welcome-text-wrapper">
                            <font-awesome-icon :icon="userIcon"></font-awesome-icon>
                            <span class="welcome-text">Welcome back<span v-if="firstName !== ''">, {{ firstName }}</span>!</span>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="errorMessages.length > 0">
                    <div class="col-12">
                        <div v-for="error in errorMessages" v-bind:key="error">
                            <div class="alert alert-danger">
                                {{error}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row home-page-box-wrapper">
                    <div class="col-xs-12 col-sm-6 col-md-4 reward-count-wrapper">
                        <div class="reward-count text-center">
                            <div class="home-page-box-icon">
                                <img src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/icon-basket.png" class="img img-fluid" />
                            </div>
                            <div v-if="rewardCount !== ''">
                                <p>You've earned</p>
                                <p class="reward-value"><strong>{{ rewardCount }} FREE</strong></p>
                                <p>products!</p>
                            </div>
                            <div v-else class="spinner-wrapper">
                                <font-awesome-icon :icon="spinnerIcon" class="spinner"></font-awesome-icon>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4 fuel-discount-wrapper">
                        <div class="fuel-discount text-center">
                            <div class="home-page-box-icon">
                                <img src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/icon-pump.png" class="img img-fluid" />
                            </div>
                            <div v-if="fuelDiscount !== ''">
                                <p>You've earned</p>
                                <p class="discount-value"><strong>{{ formatFuelDiscount(fuelDiscount) }} OFF</strong></p>
                                <p>per gallon!</p>
                            </div>
                            <div v-else class="spinner-wrapper">
                                <font-awesome-icon :icon="spinnerIcon" class="spinner"></font-awesome-icon>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-4 available-deals-wrapper">
                        <router-link to="/deals">
                            <div class="available-deals text-center">
                                <div class="home-page-box-icon">
                                    <font-awesome-icon :icon="starIcon"></font-awesome-icon>
                                </div>
                                <p>Check out all the</p>
                                <p class="text-available-deals"><strong>Available Deals</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'
import { faUserCircle, faStar, faSpinner } from '@fortawesome/free-solid-svg-icons'

export default {
    name: 'Home',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            firstName: '',
            rewardCount: '',
            fuelDiscount: '',
            errorMessages: []
        }
    },
    async mounted () {
        const profileResponse = await this.apiService.getProfile()
        if (profileResponse instanceof APIRequestError || profileResponse instanceof APIResponseError) {
            this.errorMessages.push(profileResponse.message())
        } else {
            this.firstName = profileResponse.getProperty('firstName')
        }

        const rewardCountResponse = await this.apiService.rewardCount()
        if (rewardCountResponse instanceof APIRequestError || rewardCountResponse instanceof APIResponseError) {
            this.errorMessages.push(rewardCountResponse.message())
        } else {
            this.rewardCount = rewardCountResponse.getProperty('earnCount')
        }

        const fuelDiscountBalanceResponse = await this.apiService.fuelDiscountBalance()
        if (fuelDiscountBalanceResponse instanceof APIRequestError || fuelDiscountBalanceResponse instanceof APIResponseError) {
            this.errorMessages.push(fuelDiscountBalanceResponse.message())
        } else {
            this.fuelDiscount = fuelDiscountBalanceResponse.redeemableRewards()
        }
    },
    methods: {
        formatFuelDiscount (fuelDiscount) {
            if (parseFloat(fuelDiscount) >= 1) {
                return '$' + fuelDiscount
            }
            return (parseFloat(fuelDiscount) * 100) + '¢'
        }
    },
    computed: {
        userIcon () {
            return faUserCircle
        },
        starIcon () {
            return faStar
        },
        spinnerIcon () {
            return faSpinner
        }
    }
}
</script>

<style scoped lang="scss">
    .btn {
        margin: 10px auto;
    }

    .fa-user-circle {
        width: 35px;
        height: 35px;
    }

    .welcome-text-wrapper {
        height: 55px;
        font-size: 0;

        .welcome-text {
            margin-left: 10px;
            vertical-align: top;
            font-size: 16px;
            line-height: 34px;

            span {
                vertical-align: top;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue